<template>
    <header class="flex justify-end px-6" :class="{ 'justify-between': isLms && lmsStore.pendingCourses.length === 0 }">
        <div class="gap-x-sm flex items-center" :class="{ 'ml-auto': isLms && lmsStore.pendingCourses.length > 0 }">
            <UserProfile />
        </div>
    </header>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import UserProfile from '@/components/user-profile.vue';
import { useLMSStore } from '@/stores/lms';

const isLms = computed(() => JSON.parse(localStorage.getItem('lms') ?? 'false'));
const lmsStore = useLMSStore();
</script>
